// Empire Apps Chassis · connectors/financial/dpdp-purposes
// DPDP 2023 consent purposes specific to financial connectors.
// Logged into audit log via ctx.dpdpLog().

export type FinancialPurpose =
  | 'connector-aa-read'
  | 'connector-gmail-statement-read'
  | 'connector-broker-read'
  | 'connector-mfapi-read'
  | 'connector-cas-upload'
  | 'connector-epfo-upload'
  | 'connector-ais-upload'
  | 'connector-credit-upload'
  | 'connector-razorpay-read'
  | 'connector-bbps-read'
  | 'connector-upi-export-upload'
  | 'connector-sms-inbox-android';

export const PURPOSE_LABEL: Readonly<Record<FinancialPurpose, string>> = Object.freeze({
  'connector-aa-read': 'Sahamati Account Aggregator (read-only bank statement)',
  'connector-gmail-statement-read': 'Gmail (bank statement + UPI alert parsing)',
  'connector-broker-read': 'Broker holdings + orders (read-only)',
  'connector-mfapi-read': 'Mutual fund NAV + AMFI catalog (public data)',
  'connector-cas-upload': 'Consolidated Account Statement (CAMS / Karvy) PDF upload',
  'connector-epfo-upload': 'EPFO UAN passbook upload',
  'connector-ais-upload': 'Income Tax AIS / TIS upload',
  'connector-credit-upload': 'Credit bureau report PDF upload',
  'connector-razorpay-read': 'Razorpay payment + subscription history (your merchant account)',
  'connector-bbps-read': 'Bharat BillPay recurring biller list (stub)',
  'connector-upi-export-upload': 'GPay / PhonePe / Paytm CSV export upload',
  'connector-sms-inbox-android': 'Android SMS inbox (transaction + OTP parsing)',
});

export const RETENTION_DAYS: Readonly<Record<FinancialPurpose, number>> = Object.freeze({
  'connector-aa-read': 90,
  'connector-gmail-statement-read': 90,
  'connector-broker-read': 90,
  'connector-mfapi-read': 365,
  'connector-cas-upload': 365,
  'connector-epfo-upload': 365,
  'connector-ais-upload': 730,
  'connector-credit-upload': 180,
  'connector-razorpay-read': 365,
  'connector-bbps-read': 365,
  'connector-upi-export-upload': 90,
  'connector-sms-inbox-android': 90,
});

export function logConnectorConsent(
  log: (action: string, meta: Record<string, string | number>) => void,
  purpose: FinancialPurpose,
  scope: string,
): void {
  log('connector-consent-granted', {
    purpose,
    scope,
    retentionDays: RETENTION_DAYS[purpose],
    grantedAt: Date.now(),
    version: 'connectors/financial/v1',
  });
}

export function logConnectorWithdraw(
  log: (action: string, meta: Record<string, string | number>) => void,
  purpose: FinancialPurpose,
): void {
  log('connector-consent-withdrawn', { purpose, withdrawnAt: Date.now() });
}
